export default "__VITE_ASSET__9c93b7af__"